import { Component, HostListener, Input, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-heatmap-chart',
  templateUrl: './heatmap-chart.component.html',
  styleUrl: './heatmap-chart.component.scss',
})
export class HeatmapChartComponent {
  @Input() loading = true;
  @Input() xLabels: string[] = [];
  @Input() yLabels: string[] = [];
  @Input() series: { name: string; data: number[] };

  chartOption: echarts.EChartsOption;
  chartInstance: echarts.ECharts | null = null;

  isLoading = true;

  @HostListener('window:resize', ['$event'])
  onResize() {
    if (this.chartInstance) {
      this.chartInstance.resize();
    }
  }

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    this.updateChartOptions();
    if (changes['loading']) {
      setTimeout(() => {
        this.isLoading = this.loading;
      }, 333);
    }
  }

  ngOnInit(): void {
    this.updateChartOptions();
  }

  // number to day
  numToDay(num: number): string {
    const days = ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'];
    return days[num % 7];
  }

  updateChartOptions() {
    this.chartOption = {
      tooltip: {
        position: 'top',
        formatter: (params: any) => {
          return (
            params.marker +
            '' +
            this.numToDay(params.value[1]) +
            ' - ' +
            params.value[0] +
            'h : ' +
            (params.value[2] === '-'
              ? 'Keine Daten'
              : `<b>${params.value[2]}</b>`)
          );
        },
      },
      grid: { left: 30, right: 10, top: 20, bottom: 30 },
      xAxis: {
        type: 'category',
        data: this.xLabels,
        splitArea: {
          show: true,
        },
      },
      yAxis: {
        type: 'category',
        data: this.yLabels,
        splitArea: {
          show: true,
        },
      },
      visualMap: {
        min: 0,
        max: 10,
        calculable: true,
        orient: 'horizontal',
        left: 'right',
        top: 'top',
        bottom: '0',
        text: ['Niedrig', 'Hoch'], // Texte für min und max

        textStyle: {
          color: '#000',
          align: 'center',
        },
        show: false,
      },
      series: [
        {
          // name: 'Punch Card',
          type: 'heatmap',
          data:
            this.series?.data?.map(function (item) {
              return [item[0], item[1], item[2] || '-'];
            }) || [],
          label: {
            show: true,
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowColor: 'rgba(0, 0, 0, 0.5)',
            },
          },
        },
      ],
    };
  }

  ngOnDestroy(): void {}

  onChartInit(ec: any) {
    this.chartInstance = ec;
  }
}
